var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12259_2159)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2544 30.5439H8.46443L7.75684 31.9055H20.2544V30.5439Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6732 7.43537L18.662 9.40491L14.2737 18.1122L15.9264 18.1136V18.1166L16.4306 18.1123L15.9264 19.3023V19.3191H15.9193L9.39237 31.6234L7.87744 31.6174L14.4625 19.3191H13.6654L13.6626 19.3246L12.8031 19.3212L12.1503 19.3251L12.1534 19.3191H12.1517L12.152 19.3186H12.1477L17.9653 7.77522H17.9793L19.5879 4.5835L20.402 5.97069L20.4026 5.97045L20.4143 5.9917L20.4137 5.99295L21.4862 8.17686L27.143 19.3186H27.1387L27.1389 19.3191H27.1373L27.1404 19.3251L26.4876 19.3212L25.628 19.3246L25.6252 19.3191H24.8283L31.4133 31.6174L31.385 31.6174L31.5349 31.9055H22.2017V37.1272H22.1969V37.1336H17.0938V37.1272H17.089V31.7761H18.4506V35.772H20.84V31.9055H19.0363V30.5438H29.4409L23.3714 19.3191H23.3644V19.3023L22.8601 18.1123L23.3644 18.1166V18.1136L25.017 18.1122L20.5409 9.23077L19.6732 7.43537Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4522 31.8972H17.0889V37.136H18.4522V31.8972Z",
    fill: "#F69D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2083 31.8972H20.845V37.136H22.2083V31.8972Z",
    fill: "#F69D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0896 35.7671V37.1305H22.1283V35.7671H17.0896Z",
    fill: "#F69D25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12259_2159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

export default SvgPine;